module.exports = __webpack_public_path__ + "img/notasks.148ce6ef.png";